import { render, staticRenderFns } from "./TeapAlert.vue?vue&type=template&id=aec33322"
import script from "./TeapAlert.vue?vue&type=script&lang=js"
export * from "./TeapAlert.vue?vue&type=script&lang=js"
import style0 from "./TeapAlert.vue?vue&type=style&index=0&id=aec33322&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports